import MuiSkeleton from "@mui/material/Skeleton";
import type { SkeletonProps as MuiSkeletonProps } from "@mui/material/Skeleton";
import type { ElementType, ReactNode } from "react";

export interface FormSkeletonProps extends Omit<MuiSkeletonProps, "component"> {
  loading?: boolean;
  children?: ReactNode;
  component?: ElementType;
}

export function FormSkeleton({
  variant,
  animation,
  loading,
  component,
  sx,
  children,
}: FormSkeletonProps) {
  if (!loading) {
    return children;
  }

  return (
    <MuiSkeleton
      variant={variant}
      animation={animation}
      component={component as ElementType}
      sx={sx}
    >
      {children}
    </MuiSkeleton>
  );
}
